export default __webpack_public_path__ + "static/media/line.0ff09fb2.svg";